




































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import FormProvider from '@shared/components/forms/form-provider.vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { TaxCertificate } from '@tax-certificates/interfaces/tax-certificate';
import { TaxCertificateForm as FormModel } from '@tax-certificates/interfaces/tax-certificate-form';
import { taxCertificateFields } from '@/config/tax_certificates';
import Input from '@shared/components/forms/inputs/input/input.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import CountriesSelector from '@shared/components/forms/inputs/countries-selector/countries-selector.vue';
import Section from '@shared/components/forms/inputs/section/section.vue';
import { TaxCertificatePeriod } from '@tax-certificates/interfaces/tax-certificate-period';
import TaxCertificatePeriodItemForm from '@tax-certificates/components/tax-certificate-period-item-form.vue';
import { Contact } from '@contacts/interfaces/contact';
import PostalCodeInput from '@shared/components/forms/inputs/postal-code-input/postal-code-input.vue';

@Component({
  name: 'bc-tax-certificate-form',
  components: {
    'bpc-entity-select': EntitySelect,
    'bpc-form-provider': FormProvider,
    'bpc-input': Input,
    'bpc-datepicker': Datepicker,
    'bpc-countries-selector': CountriesSelector,
    'bpc-section': Section,
    'bc-tax-certificate-period-item-form': TaxCertificatePeriodItemForm,
    'bpc-postal-code-input': PostalCodeInput,
  },
})
export default class TaxCertificateForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
      manageSaveErrors(error): void;
    };
    contactSelect: InstanceType<typeof EntitySelect> & {
      getEntities(): void;
      items: any[];
    };
  };

  @Prop(Object) readonly initialData: Partial<TaxCertificate>;
  @Prop({ type: Boolean, default: false }) readonly show: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabledContact: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabledPeriods: boolean;
  @Prop(Number) readonly modelId: number;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly value: FormModel;

  get formModel(): FormModel {
    return this.value;
  }
  set formModel(value) {
    this.$emit('input', value);
  }

  get periods(): TaxCertificatePeriod[] {
    return this.formModel.tax_certificate_periods || [];
  }

  get isDisabled(): boolean {
    return this.disabled;
  }

  get fieldsConfig() {
    return taxCertificateFields;
  }

  get label() {
    return {
      labelAttributes: {
        for: 'test',
      },
      labelClass: {
        'mt-1 mb-0': true,
      },
    };
  }
  get col2() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-2 px-2': true,
        },
      },
    };
  }
  get col4() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-4 px-2': true,
        },
      },
    };
  }
  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 px-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 px-2': true,
        },
      },
    };
  }

  saveEntity() {
    this.$refs.formProvider.saveEntity(this.formModel);
  }

  onPeriodChange(data: { index: number; value: TaxCertificatePeriod }) {
    this.formModel.tax_certificate_periods[data.index] = data.value;
  }

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({ text: 'core.superadmin_form_update_errors' });
    this.$emit('entity-error-saving', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
  }

  prepareToSave(model: FormModel) {
    return model;
  }

  onChangeContact(contactID: number) {
    const contact: Contact = this.$refs.contactSelect.items.find(
      (item: Contact) => item.id === contactID,
    );
    this.formModel.contact_firstname = contact?.contact_individual?.firstname;
    this.formModel.contact_lastname = contact?.contact_individual?.lastname;
    this.formModel.contact_birthdate = contact?.contact_individual?.birthdate;
    this.formModel.contact_national_number = contact?.contact_individual?.registration_number;
    this.formModel.contact_street = contact?.contact_detail?.street;
    this.formModel.contact_street2 = contact?.contact_detail?.street2;
    this.formModel.contact_zip = contact?.contact_detail?.zip;
    this.formModel.contact_city = contact?.contact_detail?.city;
    this.formModel.contact_country = contact?.contact_detail?.country;
  }

  onContactsLoaded() {
    // If it is a creation with a default contact_id we set by default the values
    if (!this.formModel.id && this.formModel.contact_id) {
      this.onChangeContact(this.formModel.contact_id);
    }
  }

  onSelectedContactCity(city?: string) {
    this.formModel.contact_city = city;
  }

  onSelectedBeneficiaryCity(city?: string) {
    this.formModel.beneficiary_city = city;
  }

  onSelectedContactCountry(country?: string) {
    this.formModel.contact_country = country.toLowerCase();
  }

  onSelectedBeneficiaryCountry(country?: string) {
    this.formModel.beneficiary_country = country.toLowerCase();
  }
}
